import { Button } from '@/modules/shared/components/ui/button'
import { Card, CardContent } from '@/modules/shared/components/ui/card'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/modules/shared/components/ui/select'
import { Search } from 'lucide-react'
import type { FormEvent } from 'react'
import type { ComparativePeriod } from '../../types/comparative-report.type'

export const comparativeMonths = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
]

interface Props {
  value: ComparativePeriod
  onChange: (value: ComparativePeriod) => void
  onSearch: () => void
  loading: boolean
}

export function ComparativePeriodFilter({
  value,
  onChange,
  onSearch,
  loading,
}: Props) {
  function submit(event: FormEvent) {
    event.preventDefault()
    onSearch()
  }

  return (
    <Card>
      <CardContent className="p-4">
        <form onSubmit={submit} className="flex flex-wrap items-end gap-3">
          <div className="min-w-[140px] flex-1 space-y-1">
            <label htmlFor="comparative-month" className="text-sm font-medium">
              Mês
            </label>
            <Select
              value={value.mes}
              onValueChange={(mes) => onChange({ ...value, mes })}
            >
              <SelectTrigger id="comparative-month">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {comparativeMonths.map((month, index) => (
                  <SelectItem key={month} value={String(index + 1)}>
                    {month}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="w-28 space-y-1">
            <label htmlFor="comparative-year" className="text-sm font-medium">
              Ano
            </label>
            <Select
              value={value.ano}
              onValueChange={(ano) => onChange({ ...value, ano })}
            >
              <SelectTrigger id="comparative-year">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {Array.from({ length: 5 }, (_, index) =>
                  String(new Date().getFullYear() - index),
                ).map((year) => (
                  <SelectItem key={year} value={year}>
                    {year}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <Button type="submit" disabled={loading} className="gap-2">
            <Search size={18} aria-hidden="true" />
            {loading ? 'Buscando...' : 'Buscar'}
          </Button>
        </form>
      </CardContent>
    </Card>
  )
}
